<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationValue">
    <th mat-header-cell class="header" *matHeaderCellDef>Valor da Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationValue | currency: "R$":"symbol":"1.2-2" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expenseType">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo Despesa</th>
    <td mat-cell *matCellDef="let element">
      {{ element.expenseType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Liquidação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <th mat-header-cell class="header" *matHeaderCellDef>Detalhes</th>
    <td mat-cell *matCellDef="let element">
      {{ element.details }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isNewFavored">
    <th mat-header-cell class="header" *matHeaderCellDef>É novo Favorecido?</th>
    <td mat-cell *matCellDef="let element">
      {{ element.isNewFavored ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="favoredName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Favorecido</th>
    <td mat-cell *matCellDef="let element">
      {{ element.favoredName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="favoredDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Favorecido</th>
    <td mat-cell *matCellDef="let element">
      {{ element.favoredDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="favoredBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco Favorecido</th>
    <td mat-cell *matCellDef="let element">
      {{ element.favoredBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="favoredBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência Favorecido</th>
    <td mat-cell *matCellDef="let element">
      {{ element.favoredBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="favoredAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Favorecido</th>
    <td mat-cell *matCellDef="let element">
      {{ element.favoredAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsExpenses.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsExpenses"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsExpenses"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
